var exports = {
  "i": "xe533113f--3f1183--wrapper",
};

module.exports = exports;
